export enum DomainReportDocTypeString {
  'ReportDocTypeActStr' = 'act',
  'ReportDocTypeAgentReportStr' = 'agentreport',
  'ReportDocTypeInvoiceStr' = 'invoice',
}